import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { gsap } from 'gsap';
import clsx from 'clsx';

import Icon from 'sharedComponents/Icon';
import useStyles from './useStyles';

const DesktopHeader = ({ children }) => {
  gsap.registerPlugin(ScrollTrigger);

  const classes = useStyles();
  const ref = useRef(null);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    ScrollTrigger.refresh();
    const animation = gsap.to(ref.current, {
      scrollTrigger: {
        start: 'top -80',
        end: 99999,
        trigger: ref.current,
        onToggle: self => setScrolled(self.isActive),
      },
    });
    return () => animation.scrollTrigger.disable(false);
  }, []);

  return (
    <div className={clsx(classes.container, { [classes.scrolled]: scrolled })} ref={ref}>
      <div className={classes.content}>
        <Icon name="logo" width="100" />
        {children}
      </div>
    </div>
  );
};

DesktopHeader.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DesktopHeader;



// WEBPACK FOOTER //
// ./src/components/NonAuthHomePage/components/Header/components/DesktopHeader/DesktopHeader.js